import { render, staticRenderFns } from "./DonationsMonthlyBarChart.vue?vue&type=template&id=b111cdd2&scoped=true&"
import script from "./DonationsMonthlyBarChart.vue?vue&type=script&lang=js&"
export * from "./DonationsMonthlyBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111cdd2",
  null
  
)

export default component.exports